// @flow
import Properties from "../../../Properties";
import {
  getInit,
  postInit,
  deleteInit,
  postBody
} from "../../global/types/constants";
import type { DispatchType, StateType } from "../../global/types/redux";
import { setPeopleFormError } from "./peopleActions";
import {
  SAVE_TOKEN,
  DETECT_IMAGE,
  SET_CANVAS_STATE_FACES,
  SET_LOADED_IMAGE,
  GET_ALL_TAGS,
  ADD_IMAGE_TO_FACE_SEARCH,
  SEARCH_BY_FACE,
  SET_SEARCHED_PERSON,
  SET_CURRENT_FACE
} from "../../global/actions/actionNames";
import { FaceDetectionResultType } from "../../global/types/FaceType";
import { ImageSearchInputModel } from "../types/InputModels";
import { handleResponse } from "./handleResponse";

const root = Properties.api_root;
const face_root = Properties.facedb_root;

export const setSearchToken = (token: string): DispatchType => ({
  type: SAVE_TOKEN,
  token
});

export const setLoadedImage = (imgData: string): DispatchType => ({
  type: SET_LOADED_IMAGE,
  data: imgData
});

export const setDetectedFaces = (
  detectedFaces: Array<FaceDetectionResultType>
): DispatchType => {
  return {
    type: DETECT_IMAGE,
    detectedFaces
  };
};

export const setFaceSearchImage = (imgData: string): DispatchType => ({
  type: ADD_IMAGE_TO_FACE_SEARCH,
  data: imgData
});

export const setSearchedPerson = (searchedPerson: *): DispatchType => ({
  type: SET_SEARCHED_PERSON,
  searchedPerson
});

export const setFaceSearchResult = (faceSearchResult: *): DispatchType => ({
  type: SEARCH_BY_FACE,
  faceSearchResult
});

export const setCurrentFace = (face: *): DispatchType => ({
  type: SET_CURRENT_FACE,
  face
});

export function setCanvasStateFaces(
  faces: ?Array<*>,
  selection: ?number
): DispatchType {
  return (dispatch: DispatchType) => {
    let minimalCanvasState = null;
    if (faces != null && selection != null) {
      minimalCanvasState = {
        faces: faces,
        selection: selection
      };
    }
    dispatch({
      type: SET_CANVAS_STATE_FACES,
      minimalCanvasState
    });
  };
}

export function uploadFile(
  file: File | Blob,
  completeCall: Function,
  errorCall: Function,
  isMulti: boolean = false
): DispatchType {
  let formData = new FormData();
  formData.append("image", file);
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/images", postInit(formData))
      .then((res: Response): Promise<JSON> => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 400) {
          return res.json();
        } else {
          errorCall(res.statusText);
          return Promise.reject();
        }
      })
      .then((json: JSON): * => {
        if (json.errors) {
          errorCall(json.errors.image || "Wrong Image");
        } else {
          // const token = json.tokens[0];
          let token: string = "";
          if (typeof json === "string") {
            token = json;
          } else token = json.tokens[0];

          if (!isMulti) {
            dispatch(setSearchToken(token));
          }
          dispatch(getImage(token, completeCall));
        }
      })
      .catch((err: *) => {
        errorCall(err.message);
      });
  };
}

export function getImage(token: string, doneCall?: Function): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/images/" + token + "/detect", postInit())
      .then((res: Response): Promise<JSON> => {
        return res.json();
      })
      .then((json: JSON): Function => {
        dispatch(setCanvasStateFaces());
        dispatch(setDetectedFaces(json));
        doneCall && doneCall(token);
      });
  };
}

export function getTags(): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/people/tags", getInit)
      .then((res: Response): Promise<JSON> => {
        return res.json();
      })
      .then((json: JSON): Function => {
        dispatch({ type: GET_ALL_TAGS, tags: json.tags });
      });
  };
}

// export function addTags(person: *, creatingNewPerson: boolean): DispatchType {
//   if (person.tags && person.tags.length > 0) {
//     let formData = new FormData();
//     formData.append("person_id", person.uid);
//     formData.append("tag_names", JSON.stringify(person.tags));

//     return (dispatch: DispatchType) => {
//       fetch(root + "/api/v2/tags", postInit(formData))
//         .then((res: Response): Promise<JSON> => {
//           return res.json();
//         })
//         .then((json: JSON): Function => {
//           if (creatingNewPerson) {
//             console.log(json.tags + " added");
//           }
//         })
//         .catch((reason: *) => {
//           console.error(reason);
//         });
//     };
//   } else {
//     return (dispatch: DispatchType) => {
//       console.log("no tags added");
//     };
//   }
// }
export const searchByImage =
  (form: ImageSearchInputModel, token: string) =>
  async (dispatch: DispatchType) => {
    var res = await fetch(
      `${face_root}/api/v2/images/${token}/search`,
      postBody(form)
    );
    var json = await handleResponse(res);
    dispatch(setFaceSearchResult(json));
    dispatch(getImageData(json.token));
  };
export function searchByImage_v1(search: *, token: string): DispatchType {
  let formData = new FormData();
  formData.append("eyes", JSON.stringify(search.eyes));
  formData.append("unique", search.unique);
  formData.append("search_any", search.search_any);
  formData.append(
    "display_tags",
    String(search.includetag.length > 0 || search.excludetag.length > 0)
  );
  formData.append("include_tags", JSON.stringify(search.includetag));
  formData.append("exclude_tags", JSON.stringify(search.excludetag));
  // formData.append("imagen_search", search.imagen_search);

  return (dispatch: DispatchType) => {
    dispatch(setFaceSearchImage(null));
    fetch(face_root + "/api/v1/images/" + token + "/search", postInit(formData))
      .then((res: Response): Promise<JSON> => {
        return res.json();
      })
      .then((json: JSON): * => {
        dispatch(getImageData(json.token));
        dispatch(setFaceSearchResult(json));
      });
  };
}

export function getImageData(token: string): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/images/" + token, getInit)
      .then((res: Response): Promise<Blob> => {
        return res.blob();
      })
      .then(function (blob: Blob): Function {
        let objectURL = URL.createObjectURL(blob);
        dispatch(setFaceSearchImage(objectURL));
      });
  };
}

export function getFaceFromEnrolment(
  enrolment_uid: string,
  callBack: Function
): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(
      face_root + "/api/v2/people/enrolments/" + enrolment_uid + "/cover",
      getInit
    )
      .then((res: Response): Promise<Blob> => {
        return res.blob();
      })
      .then(function (blob: Blob): Function {
        let objectURL = URL.createObjectURL(blob);
        callBack && callBack(objectURL);
      });
  };
}

export function enrolMultiple(
  person: *,
  callBack?: Function,
  failBack?: Function
): DispatchType {
  if (person.enrolments && person.enrolments.length > 0) {
    let formData = new FormData();
    let enrolments = [];
    for (var i = 0; i < person.enrolments.length; i++) {
      enrolments.push({
        token: person.enrolments[i].imgToken,
        eyes: person.enrolments[i].imgEyes
      });
    }
    formData.append("image_tokens", JSON.stringify(enrolments));

    return (dispatch: DispatchType) => {
      fetch(
        face_root + "/api/v2/people/" + person.uid + "/enrolments",
        postInit(formData)
      )
        .then((res: Response): Promise<JSON> => {
          if (res.status === 200 || res.status === 409) {
            return res.json();
          } else {
            return Promise.reject();
          }
        })
        .then(function (json: JSON): * {
          if (json.errors) {
            dispatch(setPeopleFormError(json.errors.image));
            failBack && failBack(json.errors.image);
          } else {
            let enrolment_uid = json.image_tokens[0].enrolment_uid;
            callBack && callBack(enrolment_uid);
          }
        });
    };
  } else {
    return (dispatch: DispatchType) => {
      console.log("no enrolment added");
    };
  }
}

export function addNewPerson(
  person: *,
  callBack?: Function,
  failBack?: Function
): DispatchType {
  let formData = new FormData();
  formData.append("name", person.name);

  return (dispatch: DispatchType, getState: StateType) => {
    fetch(root + "/api/v2/people", postInit(formData))
      .then((res: Response): Promise<JSON> => {
        return res.json();
      })
      .then(
        function (person: *, json: JSON) {
          person.uid = json.person_uid;
          dispatch(enrolMultiple(person));
          // dispatch(addTags(person, true));
          setTimeout(function () {
            if (getState().v3account.db.errors.form) {
              failBack && failBack(getState().v3account.db.errors.form);
            } else {
              callBack && callBack();
            }
          }, 500);
        }.bind(null, person)
      )
      .catch((error: *) => {
        failBack && failBack(error.message);
      });
  };
}

export function faceVerify(
  leftFaces: Array<*>,
  rightFaces: Array<*>,
  callBack?: Function
): DispatchType {
  let formData = new FormData();
  formData.append("left_images", JSON.stringify(leftFaces));
  formData.append("right_images", JSON.stringify(rightFaces));
  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/verify", postInit(formData))
      .then((res: Response): Promise<JSON> => {
        if (res.status === 200) {
          return res.json();
        } else {
          return Promise.reject();
        }
      })
      .then(function (json: Json) {
        callBack && callBack(json.probability);
      });
  };
}
